// Views
import Home from '../views/Home';
import ErrorFallback from '../views/ErrorFallback';
// Components
import Layout from '../components/templates/Layout';
import ProtectedRoute from './ProtectedRoute';
// Cortizol and Parazol routes
import { cortizolPrivateRoutes, cortizolPublicRoutes } from './cortizol/routes';
import { parazolPrivateRoutes } from './parazol/routes';
import { garageExclusionsPrivateRoutes } from './garage-exclusions/routes';
import { specialCollectionsPrivateRoutes } from './special-collections/routes';

/**
 *  @type {Route[]}
 */
const publicRoutes = [
  ...cortizolPublicRoutes,
];

/**
 *  @type {Route[]}
 */
const privateRoutes = [
  {
    element: <ProtectedRoute><Layout /></ProtectedRoute>,
    children: [
      {
        path: '/',
        element: <Home />,
        errorElement: <ErrorFallback />,
      },
      ...cortizolPrivateRoutes,
      ...parazolPrivateRoutes,
      ...garageExclusionsPrivateRoutes,
      ...specialCollectionsPrivateRoutes,
    ],
    errorElement: <ErrorFallback />,
  },
];

export default [
  ...publicRoutes,
  ...privateRoutes,
];
